export const isLegacyVod = src => {
    return src && (
        src.includes('vod.coassemble.com') ||
        src.includes('cdn.coassemble.com')
    );
};

export const isMux = src => {
    return src && src.includes('stream.mux.com');
};

export const isYoutube = src => {
    const match = src.match(/(?:https?:\/\/)?(?:www\.|m\.)?youtu(?:\.be\/|be.com\/\S*(?:watch|embed)(?:(?:(?=\/[^&\s?]+(?!\S))\/)|(?:\S*v=|v\/)))([^&\s?]+)/gi);
    return match && match.length > 0;
};
export const getYoutubeId = src => {
    const match = src.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/);
    return (match && match[7].length === 11)? match[7] : false;
};

export const isVimeo = src => src.includes('vimeo.com');
export const getVimeoId = src => {
    if (!isVimeo(src)) return null;
    return src.match(/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/i)[1];
};

// Convert from TimeRanges into completion progress array:
// [0, 4, 5, 10]
export const rangesToCompletionProgress = timeRanges => {
    if (!timeRanges) return [];

    return Array.from(timeRanges).flatMap((_, index) => {
        return [
            Math.round(timeRanges.start(index)),
            Math.round(timeRanges.end(index))
        ];
    });
};

// Convert from completion progress array (see above) to progress total:
export const completionProgressToTotal = progress => {
    let total = 0;
    if (!progress) return total;

    // Add ranges together, e.g: [0, 1, 3, 4] -> (1 - 0) + (4 - 3) -> 2
    for (let index = 1; index < progress.length; index += 2) {
        const first = progress[index - 1];
        const second = progress[index];
        if ((first === undefined) || (second === undefined)) continue;

        total += second - first;
    }

    return total;
};
